var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarCourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.22461C11.21 8.22461 13 6.43461 13 4.22461C13 2.01461 11.21 0.224609 9 0.224609C6.79 0.224609 5 2.01461 5 4.22461C5 6.43461 6.79 8.22461 9 8.22461ZM9 2.22461C10.1 2.22461 11 3.12461 11 4.22461C11 5.32461 10.1 6.22461 9 6.22461C7.9 6.22461 7 5.32461 7 4.22461C7 3.12461 7.9 2.22461 9 2.22461ZM9 10.7746C6.64 8.57461 3.48 7.22461 0 7.22461V18.2246C3.48 18.2246 6.64 19.5746 9 21.7746C11.36 19.5846 14.52 18.2246 18 18.2246V7.22461C14.52 7.22461 11.36 8.57461 9 10.7746ZM16 16.3546C13.47 16.6946 11.07 17.6546 9 19.1746C6.94 17.6546 4.53 16.6846 2 16.3446V9.39461C4.1 9.77461 6.05 10.7446 7.64 12.2246L9 13.5046L10.36 12.2346C11.95 10.7546 13.9 9.78461 16 9.40461V16.3546Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarCourse);
export default __webpack_public_path__ + "static/media/sidebarCourse.284dae955400ffba8ac7339f38029482.svg";
export { ForwardRef as ReactComponent };